module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/babel-loader/lib/index.js!./RoleListing.js"));
	}, "admin");
}


//////////////////
// WEBPACK FOOTER
// ./src/features/users/RoleListing.js
// module id = 1996
// module chunks = 4